import {
  Box,
  Button,
  Stack,
  Typography,
  useTheme,
  alpha,
  Chip,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { CheckCircle, Rocket } from "@mui/icons-material";
import React from "react";
import { TranslateContext } from "../../../context/TranslateContext";

const BuyHostingButton = () => {
  const { data } = React.useContext(TranslateContext);
  const theme = useTheme();

  const handleClick = () => {
    const phoneNumber = "918430088300";
    const message = encodeURIComponent(
      "I need recommended hosting with free installation for my app.",
    );
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  const features = [data.freeAppIns, data.oneYrHos, data.sameRenewPrice];

  return (
    <Box
      sx={{
        p: 4,
        borderRadius: 4,
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.success.main,
          0.08,
        )}, ${alpha(theme.palette.primary.main, 0.05)})`,
        border: `2px solid ${alpha(theme.palette.success.main, 0.2)}`,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: -100,
          right: -100,
          width: 200,
          height: 200,
          borderRadius: "50%",
          background: `radial-gradient(circle, ${alpha(
            theme.palette.success.main,
            0.15,
          )}, transparent)`,
        },
      }}
    >
      <Stack spacing={3} alignItems="center" position="relative" zIndex={1}>
        {/* Badge */}
        <Chip
          icon={<Rocket />}
          label="RECOMMENDED"
          color="success"
          sx={{
            fontWeight: 700,
            fontSize: "0.75rem",
            letterSpacing: "0.5px",
          }}
        />

        {/* Title */}
        <Typography
          variant="h5"
          fontWeight={800}
          textAlign="center"
          sx={{
            background: `linear-gradient(135deg, ${theme.palette.success.main}, ${theme.palette.primary.main})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {data.recomHos}
        </Typography>

        {/* Features */}
        <Stack
          direction="row"
          spacing={2}
          flexWrap="wrap"
          justifyContent="center"
        >
          {features.map((item, index) => (
            <Chip
              key={index}
              icon={<CheckCircle />}
              label={item}
              variant="outlined"
              color="success"
              sx={{
                fontWeight: 600,
                borderWidth: 2,
                "&:hover": {
                  bgcolor: alpha(theme.palette.success.main, 0.1),
                },
              }}
            />
          ))}
        </Stack>

        {/* CTA Button */}
        <Button
          variant="contained"
          size="large"
          startIcon={<WhatsAppIcon />}
          onClick={handleClick}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: 3,
            fontSize: "1.1rem",
            fontWeight: 700,
            textTransform: "none",
            background: "#25D366",
            boxShadow: `0 8px 24px ${alpha("#25D366", 0.4)}`,
            "&:hover": {
              background: "#1da851",
              transform: "translateY(-2px)",
              boxShadow: `0 12px 32px ${alpha("#25D366", 0.5)}`,
            },
            transition: "all 0.3s ease",
          }}
        >
          Get Started Now
        </Button>
      </Stack>
    </Box>
  );
};

export default BuyHostingButton;
